var _ref2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24.125,
    height: 21.97,
    viewBox: "0 0 24.125 21.97",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("path", {
    id: "Path_27984",
    "data-name": "Path 27984",
    d: "M110.09,54.995l-8.039,6.159V71.447h4.923v-7.94a.537.537,0,0,1,.536-.536h5.159a.537.537,0,0,1,.536.536v7.94h4.923V61.154Zm4.9-3.843H117.1a.537.537,0,0,1,.536.536v4.5l3.863,2.96a1.66,1.66,0,0,1,.631,1.054l0,.02a1.659,1.659,0,0,1-.267,1.178l-.175.259a1.651,1.651,0,0,1-2.389.389l-.1-.077V71.983a.537.537,0,0,1-.536.536H101.514a.537.537,0,0,1-.536-.536V61.975l-.1.077a1.653,1.653,0,0,1-2.387-.389l-.176-.259a1.661,1.661,0,0,1,.366-2.253l11.085-8.492a.535.535,0,0,1,.656.005l4.037,3.093v-2.07a.537.537,0,0,1,.536-.536Zm1.816,5.755a.521.521,0,0,1-.065-.049l-2.076-1.59-.013-.01-4.567-3.5L99.329,60a.591.591,0,0,0-.129.8l.174.259a.585.585,0,0,0,.854.138l9.531-7.3a.535.535,0,0,1,.656-.005l9.538,7.306a.6.6,0,0,0,.216.108.6.6,0,0,0,.241.008.545.545,0,0,0,.4-.253l.175-.259a.6.6,0,0,0,.1-.417l0-.011A.592.592,0,0,0,120.85,60l-4.041-3.1Zm-.246-4.682H115.53v2.354l1.034.792Zm-8.517,19.222h4.087v-7.4h-4.087Z",
    transform: "translate(-98.027 -50.55)",
    fill: "#3c3c3b"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.be793baa.svg";
export { ForwardRef as ReactComponent };